import type { SVGProps } from 'react'

export type IconName =
  | 'flight'
  | 'car'
  | 'hotel'
  | 'people'
  | 'person'
  | 'archive'
  | 'article'
  | 'arrow-down'
  | 'arrow-up'
  | 'arrow-left'
  | 'arrow-right'
  | 'audio'
  | 'bag'
  | 'bell'
  | 'bell-off'
  | 'bell-plus'
  | 'book'
  | 'bump'
  | 'calendar'
  | 'capture'
  | 'check'
  | 'chevron'
  | 'clock'
  | 'cloud'
  | 'cloud-upload'
  | 'close'
  | 'context'
  | 'copy'
  | 'code'
  | 'document'
  | 'edit'
  | 'external'
  | 'expand'
  | 'facebook'
  | 'format'
  | 'home'
  | 'help'
  | 'filter'
  | 'flash'
  | 'film'
  | 'checklist'
  | 'link'
  | 'list'
  | 'list-reorder'
  | 'layout-grid'
  | 'layout-cards'
  | 'layout-list'
  | 'layout-minimal'
  | 'layout-table'
  | 'image'
  | 'instagram'
  | 'new'
  | 'more'
  | 'merge'
  | 'moon'
  | 'phone'
  | 'pin'
  | 'play'
  | 'post'
  | 'qr'
  | 'quote'
  | 'recipe'
  | 'ticket'
  | 'reddit'
  | 'repeat'
  | 'repeat-circular'
  | 'search'
  | 'settings'
  | 'select-multiple'
  | 'spark'
  | 'sun'
  | 'tag'
  | 'trash'
  | 'keyboard'
  | 'remove-line'
  | 'scissors'
  | 'tiktok'
  | 'undo'
  | 'redo'
  | 'upload-error'
  | 'view'
  | 'view-off'
  | 'x'

const paths: Record<IconName, React.ReactNode> = {
  car: <path d="M4 16v-3l2-5.5A2 2 0 0 1 7.9 6h8.2a2 2 0 0 1 1.9 1.5L20 13v3H4Zm0 0v2.5M20 16v2.5M4 13h16M7.5 13.5h.01M16.5 13.5h.01" />,
  flight: <path d="m3 11 7 1 7-8c1-1 3 0 2 2l-5 8 3 4-2 2-4-3-4 3-2-1 3-5-5-1v-2Z"/>,
  hotel: <path d="M4 21V3h12v18M2 21h20M16 10h4v11M7 7h2m2 0h2M7 11h2m2 0h2M8 21v-6h4v6"/>,
  people: <><circle cx="9" cy="8" r="3"/><path d="M3 21v-3a6 6 0 0 1 12 0v3m1-16a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 4v3"/></>,
  person: <><circle cx="12" cy="8" r="3"/><path d="M5 21v-2a7 7 0 0 1 14 0v2"/></>,
  scissors: <><circle cx="6" cy="6" r="2.5"/><circle cx="6" cy="18" r="2.5"/><path d="M8 7.5 20 18M8 16.5 20 6"/></>,
  settings: <><path d="m9.5 3-.7 2.1-2 .9-2.1-.5L2.8 8.8l1.5 1.6v2.3l-1.5 1.6 1.9 3.3 2.1-.5 2 .9.7 2.1h3.8l.7-2.1 2-.9 2.1.5 1.9-3.3-1.5-1.6v-2.3l1.5-1.6-1.9-3.3-2.1.5-2-.9L13.3 3z"/><circle cx="11.4" cy="11.5" r="3"/></>,
  archive: <path d="M4 7.5h16v12H4v-12Zm-1-4h18v4H3v-4Zm6 8h6" />,
  article: <path d="M6 3.5h9l3 3V21H6V3.5Zm9 0V7h3M9 11h6m-6 4h6m-6 4h4" />,
  'arrow-down': <path d="M12 4v16m-6-6 6 6 6-6" />,
  'arrow-up': <path d="M12 20V4m-6 6 6-6 6 6" />,
  'arrow-left': <path d="M20 12H4m6-6-6 6 6 6" />,
  'arrow-right': <path d="M4 12h16m-6-6 6 6-6 6" />,
  audio: <path d="M9 18V6l10-2v12M9 9l10-2M6.5 20A2.5 2.5 0 1 0 6.5 15a2.5 2.5 0 0 0 0 5Zm10-2A2.5 2.5 0 1 0 16.5 13a2.5 2.5 0 0 0 0 5Z" />,
  bag: <path d="M5 8h14l-1 13H6L5 8Zm4 2V7a3 3 0 0 1 6 0v3" />,
  bell: <path d="M18 9a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />,
  'bell-off': <path d="M18 9a6 6 0 0 0-9.2-5.2M5.4 5.4A5.9 5.9 0 0 0 6 9c0 7-3 7-3 9h15M10 21h4M3 3l18 18" />,
  'bell-plus': <path d="M18 9a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4m5-16v6m-3-3h6" />,
  book: <path d="M4 5.5A3.5 3.5 0 0 1 7.5 2H12v18H7.5A3.5 3.5 0 0 0 4 23V5.5ZM20 5.5A3.5 3.5 0 0 0 16.5 2H12v18h4.5A3.5 3.5 0 0 1 20 23V5.5Z" />,
  bump: <path d="M12 19V5m-5 5 5-5 5 5M6 21h12" />,
  calendar: <path d="M5 5h14v15H5V5Zm3-2v4m8-4v4M5 9h14m-10 4h2m2 0h2m-6 3h2m2 0h2" />,
  capture: <path d="M5 19h4l10.3-10.3a2.2 2.2 0 0 0-4-4L5 15v4Zm9-13 4 4" />,
  check: <path d="m5 12 4 4L19 6" />,
  chevron: <path d="m8 10 4 4 4-4" />,
  clock: <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v5l3 2" />,
  cloud: <path d="M7 18h10a4 4 0 0 0 .7-7.9A6 6 0 0 0 6.3 8.5 4.8 4.8 0 0 0 7 18Z" />,
  'cloud-upload': <path d="M7 19h10a4 4 0 0 0 .7-7.9A6 6 0 0 0 6.3 9.5 4.8 4.8 0 0 0 7 19Zm5-4V8m-3 3 3-3 3 3" />,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  // Supplied 08-constellation.svg; preserve its fills, geometry and opacity hierarchy.
  context: <g fill="currentColor" stroke="none"><path d="m7 7 11 3-6 9Z" fill="none" stroke="currentColor" strokeWidth="1.5" opacity=".3"/><circle cx="7" cy="7" r="4"/><circle cx="18" cy="10" r="3" opacity=".72"/><circle cx="12" cy="19" r="2.5" opacity=".5"/></g>,
  copy: <path d="M8 8h11v12H8V8Zm-3 8H4V4h11v1" />,
  code: <path d="m8 8-4 4 4 4m8-8 4 4-4 4m-2-11-4 14" />,
  document: <path d="M6 3h8l4 4v14H6V3Zm8 0v5h4M9 12h6m-6 4h6" />,
  edit: <path d="M4 20h4l11-11a2.8 2.8 0 0 0-4-4L4 16v4Zm9.5-13.5 4 4" />,
  external: <path d="m4 20 16-16M10 4h10v10" />,
  expand: <path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7" />,
  facebook: <path d="M14 21v-8h2.8l.4-3H14V8.2c0-.9.3-1.5 1.6-1.5H17V4.1c-.4-.1-1.2-.1-2.1-.1-2.3 0-3.9 1.4-3.9 4V10H8v3h3v8h3Z" />,
  format: <path d="M5 7V4h14v3M9 20h6M12 4v16" />,
  home: <path d="m3.5 11 8.5-7 8.5 7M6 9.5V20h12V9.5M12 14v6m-2-3h4" />,
  help: <><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 2-2.5 2-2.5 4m0 3.5h.01"/></>,
  filter: <path d="M4 6h16M7 12h10m-7 6h4" />,
  flash: <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" />,
  film: <path d="M4 5h16v14H4V5Zm4 0v14m8-14v14M4 9h4m8 0h4M4 15h4m8 0h4" />,
  checklist: <path d="m3.5 6.5 1.5 1.5 2.5-3M10 7h10M3.5 13l1.5 1.5 2.5-3M10 13h10M3.5 19l1.5 1.5 2.5-3M10 19h10" />,
  link: <path d="m10 13 4-4m-5.5 7.5-1 1a3.5 3.5 0 0 1-5-5l3-3a3.5 3.5 0 0 1 5 0m5-2 1-1a3.5 3.5 0 0 1 5 5l-3 3a3.5 3.5 0 0 1-5 0" />,
  list: <path d="M4 6h.01M8 6h12M4 12h.01M8 12h12M4 18h.01M8 18h12" />,
  'list-reorder': <path d="m5 9 7-7 7 7M5 15l7 7 7-7" />,
  'layout-grid': <path d="M4 4h7v9H4V4Zm10 0h6v5h-6V4ZM4 16h7v4H4v-4Zm10-4h6v8h-6v-8Z" />,
  'layout-cards': <path d="M3.5 4.5h8v15h-8v-15Zm11 0h6v15h-6v-15ZM6 8h3m-3 3h3m8-3h1m-1 3h1" />,
  'layout-list': <path d="M4 5h16v5H4V5Zm0 9h16v5H4v-5Z" />,
  'layout-minimal': <path d="M4 5h16M4 9h11M4 14h16M4 18h9" />,
  'layout-table': <path d="M4 5h16v14H4V5Zm0 5h16M4 14.5h16M10 5v14" />,
  image: <path d="M4 5h16v14H4V5Zm3 10 3-3 2.5 2.5 2-2L19 17M9 9h.01" />,
  instagram: <path d="M7.5 3.5h9A4.5 4.5 0 0 1 21 8v8a4.5 4.5 0 0 1-4.5 4.5h-9A4.5 4.5 0 0 1 3 16V8a4.5 4.5 0 0 1 4.5-4.5ZM12 16.5A4.5 4.5 0 1 0 12 7.5a4.5 4.5 0 0 0 0 9Zm5.1-9.7h.01" />,
  new: <path d="M12 5v14M5 12h14" />,
  // Three dots carry little ink at the shared stroke: heavier, so a ⋯ menu is easy to find.
  more: <path d="M5 12h.01M12 12h.01M19 12h.01" strokeWidth="3.2" />,
  merge: <><path d="M7 4v3a5 5 0 0 0 5 5h5" /><path d="M7 20v-3a5 5 0 0 1 5-5" /><path d="m14 9 3 3-3 3" /></>,
  moon: <path d="M20.5 15.2A8.5 8.5 0 0 1 8.8 3.5 8.5 8.5 0 1 0 20.5 15.2Z" />,
  phone: <path d="M6.6 3.5 9 3l1.6 4.2-2 1.4a11 11 0 0 0 6.8 6.8l1.4-2L21 15l-.5 2.4a2 2 0 0 1-2 1.6A15.5 15.5 0 0 1 5 5.5a2 2 0 0 1 1.6-2Z" />,
  pin: <path d="M12 22s7-6.2 7-13a7 7 0 1 0-14 0c0 6.8 7 13 7 13Zm0-10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />,
  play: <path d="M7 4.5v15l12-7.5L7 4.5Z" />,
  post: <path d="M5 5h14v11H9l-4 4V5Zm4 4h6m-6 3h4" />,
  reddit: <path d="M5 13.5c0 3.3 3.1 5.5 7 5.5s7-2.2 7-5.5-3.1-5.5-7-5.5-7 2.2-7 5.5Zm2.3-2.1-1.7-1.2m10.9 1.2 1.7-1.2M9 13h.01m6 0h.01M9.5 16c1.4.9 3.6.9 5 0m.2-8.8 1-2.7 2.1.8m-.7-1.2.7 1.2 1.3-.2" />,
  repeat: <path d="M17 3l4 4-4 4M3 7h18M7 21l-4-4 4-4m14 4H3" />,
  'repeat-circular': <><path d="M20.5 15C18.9558 18.0448 15.7622 21 12 21C7.14776 21 3.58529 17.5101 3 13" strokeWidth="2" /><path d="M3.5 9C4.89106 5.64934 8.0647 3 12 3C16.7819 3 20.4232 6.48993 21 11" strokeWidth="2" /><path d="M21 21V15.6C21 15.2686 20.7314 15 20.4 15H15" strokeWidth="2" strokeLinejoin="round" /><path d="M9 9H3.6C3.26863 9 3 8.73137 3 8.4V3" strokeWidth="2" strokeLinejoin="round" /></>,
  search: <path d="m20 20-4.2-4.2M18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />,
  'select-multiple': <><path d="M5 4h14v16H5V4Z" /><path d="m8 12 2.5 2.5L16 9" /></>,
  spark: <path d="m12 3 1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3Zm6 13 .7 2.3L21 19l-2.3.7L18 22l-.7-2.3L15 19l2.3-.7L18 16Z" />,
  sun: <><circle cx="12" cy="12" r="3.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"/></>,
  tag: <path d="M3.5 12V5.5A2.5 2.5 0 0 1 6 3h6.5L21 11.5a2.1 2.1 0 0 1 0 3L14.5 21a2.1 2.1 0 0 1-3 0L3.5 13a1.4 1.4 0 0 1 0-1Zm4-4h.01" />,
  trash: <path d="M4 7h16M9 7V4h6v3m3 0-1 14H7L6 7m4 4v6m4-6v6" />,
  keyboard: <><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M6.5 10h.01m3 0h.01m3 0h.01m3 0h.01M6.5 13h.01m3 0h.01m3 0h.01m3 0h.01M8 16h8" /></>,
  'remove-line': <><path d="M4 7h16M4 17h6m4 0h6" /><path d="m11 13 2 2m0-2-2 2" /></>,
  tiktok: <path d="M14 4v10.4a3.4 3.4 0 1 1-2.4-3.2V7.1c2.1 2.2 4.2 2.8 6.4 2.8V7.1c-1.7 0-3.1-1.2-4-3.1Z" />,
  undo: <path d="m9 7-5 5 5 5M5 12h8a6 6 0 0 1 6 6" />,
  quote: <path d="M5 18c2.5-1 4-3.2 4-6V7H4v5h4M15 18c2.5-1 4-3.2 4-6V7h-5v5h4" />,
  recipe: <path d="M4 11h16a8 8 0 0 1-16 0Zm8-7v3m-4-2v2m8-2v2M9 21h6" />,
  ticket: <path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4V8Zm11-2v12" />,
  qr: <><rect x="4" y="4" width="6" height="6" rx="1" /><rect x="14" y="4" width="6" height="6" rx="1" /><rect x="4" y="14" width="6" height="6" rx="1" /><path d="M14 14h2v2h-2zM18 14h2M14 18v2M18 18h2v2h-2z" /></>,
  redo: <path d="m15 7 5 5-5 5m4-5h-8a6 6 0 0 0-6 6" />,
  'upload-error': <path d="M6 3.5h8l4 4V21H6V3.5Zm8 0V8h4M12 10v5m0 3h.01" />,
  view: <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />,
  'view-off': <path d="m3 3 18 18M9.9 6.2A10.8 10.8 0 0 1 12 6c6 0 9.5 6 9.5 6a19 19 0 0 1-3 3.6M6.1 6.1A20 20 0 0 0 2.5 12s3.5 6 9.5 6c1.7 0 3.2-.5 4.5-1.2M9.9 9.9a3 3 0 0 0 4.2 4.2" />,
  x: <path d="M5 4l14 16M19 4 5 20" />,
}

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName
}

export function Icon({ name, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {paths[name]}
    </svg>
  )
}
